import React from 'react'

function CheckBoxUi({ checkBoxLabel, onChange, value, checked, disabled }) {
    return (
        <div class="form-check">
            <input
                className="form-check-input"
                type="checkbox"
                onChange={onChange}
                checked={checked}
                id={checkBoxLabel}
                value={value}
                disabled={disabled}
            />
            <label class="form-check-label" htmlFor={checkBoxLabel}>
                {checkBoxLabel}
            </label>
        </div>
    )
}

export default CheckBoxUi